import { AddressDTO, CustomerForEditionDTO, PaymentMethodDTO, Res, SalesOrderDraftDTO, SalesOrderParamsFromTakeOutDTO, SalesOrderType, TicketDTO } from 'core/api';
import { buildDateTime } from 'core/utils/DateUtils';

export type EndTakeOutOrderData = {
	address: AddressDTO;
	deliveryDate: Nullable<Date>,
	deliveryTime: Nullable<Date>,
	customerFiscalName: string;
	customerPhone: string;
	customerEmail: string;
	contactName: string;

	netAmount: number;
	notes: string;
	serialNumber: string;
	type: SalesOrderType;

	preferredPaymentMethod: Nullable<PaymentMethodDTO>;
	changeNeeded: number;
};

export function createEndTakeOutOrderData(draft: SalesOrderDraftDTO, ticket: TicketDTO, customer: CustomerForEditionDTO): EndTakeOutOrderData {

	const regex = new RegExp('^\\D*(\\d+(?:\\.|,\\d+)?)');
	const change = draft.Notes.split('\n').filter(x => regex.test(x)).map(x => {
		const change = parseFloat(regex.exec(x)![1].replace(',', '.'));
		return {
			change,
			isChange: x.includes(Res.Web.END_TAKE_OUT_ORDER_CHANGE_NEEDED_NOTE(change))
		};
	}).filter(x => x.isChange).map(x => x.change)[0] || 0;


	return {
		address: draft.DeliveryAddress,
		deliveryDate: draft.DeliveryDate,
		deliveryTime: draft.DeliveryDate,
		customerFiscalName: ticket.Customer.FiscalName,
		contactName: customer.ContactPerson,
		customerPhone: customer.Telephone,
		customerEmail: customer.Email,
		netAmount: ticket.NetAmount,
		notes: draft.Notes.replace(Res.Web.END_TAKE_OUT_ORDER_CHANGE_NEEDED_NOTE(change), ''),
		serialNumber: `${draft.SerialNumber.SerieName}-${draft.SerialNumber.Number}`,
		type: draft.Type,
		changeNeeded: change,
		preferredPaymentMethod: draft.PreferredPaymentMethod.Id === 0 ? null : draft.PreferredPaymentMethod
	};
}

export function toTakeOutOrderParams(draft: SalesOrderDraftDTO, model: EndTakeOutOrderData): SalesOrderParamsFromTakeOutDTO {
	const notes: string[] = [model.notes];

	if (model.changeNeeded)
		notes.push(Res.Web.END_TAKE_OUT_ORDER_CHANGE_NEEDED_NOTE(model.changeNeeded));

	return {
		DeliveryAddress: draft.DeliveryAddress,
		DeliveryDate: model.deliveryDate && model.deliveryTime ? buildDateTime(model.deliveryDate, model.deliveryTime) : new Date(),
		DraftSerialNumber: draft.SerialNumber,
		Notes: notes.filter(x => x !== '').join('\n'),
		Type: model.type,
		// Necesito el "as" porque quiero pasar un null, pero los DTOs que generamos no lo soportan
		PreferredPaymentMethod: model.preferredPaymentMethod as PaymentMethodDTO
	};
}